<template>
  <div class="titlebar">
    <div class="first-row">
      <div @click="handleBackAction" class="back-btn" :class="{ show: null != backAction }">
        <font-awesome-icon icon="chevron-left"/>
      </div>

      <div class="title">
        <span v-html="title"></span>
      </div>

      <div @click="showNav" class="menu-btn hide-on-desktop">
        <font-awesome-icon icon="bars"/>
      </div>

      <div v-if="asClient" class="client-simulator hide-on-mobile">
        Vous êtes connecté sur le client :
        {{ clientInfos.code }} - {{ clientInfos.society_name }}
      </div>
      <LanguageSelection v-if="Utils.getTheme()!=='suividefotte'" style="margin-left: auto;"/>
    </div>

    <div class="second-row">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import Utils from "../../services/utils";
import LanguageSelection from "../language/LanguageSelection.vue";

export default {
  name: '',

  components: {
    LanguageSelection,
  },

  computed: {
    Utils() {
      return Utils
    },
    ...mapGetters({
      title: 'UI/viewTitle',
      backAction: 'UI/backAction',
      clientInfos: 'Papers/clientInfos',
    }),

    asClient() {
      return !!sessionStorage.getItem('AS_CLIENT')
    },

    beepizMode() {
      return window.location.host.includes('beepiz')
    },
  },

  methods: {
    ...mapMutations({
      showNav: 'UI/showNav',
    }),

    handleBackAction() {
      if (null != this.backAction) {
        if ('historyBack' == this.backAction) {
          if (null != this.$route.query.token) {
            this.$router.push(this.$route.meta.fallback)
          } else {
            this.$router.go(-1)
          }
        } else if ('emitEvent' == this.backAction) {
          this.$emit('back')
        } else {
          this.$router.replace(this.backHistory)
        }
      }
    },
  },
}
</script>

<style lang="scss">
.titlebar {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;

  .first-row {
    display: flex;
    flex-direction: row;
    position: relative;
    background-color: $main-color;

    .back-btn,
    .menu-btn {
      color: $main-white;
      display: flex;
      font-size: 2.5rem;
      align-items: center;
      justify-content: center;
    }

    .back-btn {
      pointer-events: none;
      opacity: 0;
      transition-property: opacity;
      cursor: pointer;

      &.show {
        opacity: 1;
        pointer-events: all;
      }
    }

    .title {
      color: $main-white;
      display: flex;
      flex-basis: 100%;
      font-size: 1.4rem;
      font-weight: $bold;
      align-items: center;
    }

    .client-simulator {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ff7000;
      position: absolute;
      right: 0;
      width: 300px;
      height: 100%;
      padding: 10px;
      text-align: center;
      color: $main-white;
      font-weight: $bold;
    }
  }

  .second-row {
    .filter {
      background-color: #f9f9f9;
      box-shadow: 0 2px 0 rgba(0, 0, 0, 0);

      &:hover {
        background-color: #ffffff;
        box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
      }
    }
  }
}

.sfr {
  .titlebar {
    .first-row {
      background-color: $sfr-color;
    }
  }
}

.beepiz {
  .titlebar {
    .first-row {
      background-color: $beepiz-color;

      .back-btn,
      .menu-btn {
        color: $main-black;
      }

      .title {
        color: $main-black;
        font-size: 1.5rem;
        font-weight: 650;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/TitleBar.vue